export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Institucional']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Termos de Uso',
        to: '/terms',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Política de Privacidade',
        to: '/privacy_policy',
        icon: 'cil-lock-locked'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Posts']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Recados',
        to: '/posts/list',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Publicar recado',
        to: '/posts/create',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Usuários']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar usuários',
        to: '/users/list',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Eventos']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar eventos',
        to: '/events/list',
        icon: 'cil-calendar'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Configurações']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Templates de mensagens',
        to: '/settings/message_templates',
        icon: 'cil-envelope-closed'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Configurações de sistema',
        to: '/settings/system',
        icon: 'cil-settings'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Banners da home']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar banners',
        to: '/banners/list',
        icon: 'cil-image'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Adicionar banner',
        to: '/banners/create',
        icon: 'cil-image-plus'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Configurações da Home']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Vídeo da home',
        to: '/home/video',
        icon: 'cil-video'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Seção: Pra quem é',
        to: '/home/target',
        icon: 'cil-bookmark'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Seção: Comece Agora',
        to: '/home/start_now',
        icon: 'cil-bookmark'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Fotos da home',
        to: '/home/photos',
        icon: 'cil-bookmark'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['FAQ']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar perguntas do FAQ',
        to: '/frequently_asked_questions/list',
        icon: 'cil-chat-bubble'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Adicionar pergunta ao FAQ',
        to: '/frequently_asked_questions/create',
        icon: 'cil-chat-bubble'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Sympla']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Adicionar Evento Sympla',
        to: '/sympla_events/create',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar Eventos Sympla',
        to: '/reports/sympla_events',
        icon: 'cil-plus'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Adicionar Token Sympla',
        to: '/sympla_tokens/create',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Listar Tokens Sympla',
        to: '/sympla_tokens/list',
        icon: 'cil-plus'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Relatórios']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Categorias de Profissionais',
        to: '/reports/professional_category',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Cadastros incompletos',
        to: '/reports/incomplete_accounts',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Cadastros sem vídeo',
        to: '/reports/no_video_work_profiles',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Perfis melhores avaliados',
        to: '/reports/best_rated_profiles',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logs de notificações',
        to: '/reports/messaging_log',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Relatório de jobs',
        to: '/reports/sympla_jobs_report',
        icon: 'cil-speedometer'
      },
    ]
  }
]
